import { useEffect, useState } from 'react';
import { Lock } from 'lucide-react';

interface DocumentNumberInputProps {
  value: string;
  onChange: (fullNumber: string) => void;
  disabled?: boolean;
  className?: string;
  label?: string;
}

export default function DocumentNumberInput({
  value,
  onChange,
  disabled = false,
  label = 'Document Number',
}: DocumentNumberInputProps) {
  const [prefix, setPrefix] = useState('');
  const [suffix, setSuffix] = useState('');

  useEffect(() => {
    if (value) {
      const parts = value.trim().split('-');
      if (parts.length >= 3) {
        const p = parts.slice(0, -1).join('-') + '-';
        const s = parts[parts.length - 1];
        setPrefix(p);
        setSuffix(s);
      } else {
        const lastIndex = value.search(/\d+$/);
        if (lastIndex !== -1) {
          setPrefix(value.substring(0, lastIndex));
          setSuffix(value.substring(lastIndex));
        } else {
          setPrefix(value + '-');
          setSuffix('0001');
        }
      }
    }
  }, [value]);

  const handleSuffixChange = (newSuffix: string) => {
    const cleanSuffix = newSuffix.replace(/\D/g, '');
    setSuffix(cleanSuffix);
    onChange(`${prefix}${cleanSuffix}`);
  };

  return (
    <div>
      {label && (
        <label className="block text-xs font-semibold text-slate-500 uppercase tracking-wide mb-1.5">
          {label} <span className="text-slate-400 font-normal">(Prefix Locked)</span>
        </label>
      )}
      <div className="flex rounded-lg border border-slate-300 shadow-xs focus-within:border-indigo-500 focus-within:ring-1 focus-within:ring-indigo-500 bg-white overflow-hidden">
        <span className="flex items-center gap-1 bg-slate-100 px-3 py-2 font-mono text-xs font-semibold text-slate-600 border-r border-slate-200 select-none shrink-0">
          <Lock className="h-3 w-3 text-slate-400" />
          {prefix}
        </span>
        <input
          type="text"
          value={suffix}
          onChange={(e) => handleSuffixChange(e.target.value)}
          disabled={disabled}
          placeholder="0001"
          className="w-full bg-white px-3 py-2 font-mono text-xs font-bold text-indigo-700 outline-none placeholder:text-slate-300 disabled:bg-slate-50 disabled:text-slate-500"
        />
      </div>
    </div>
  );
}
